export default {
    access_token: process.env.VUE_APP_MAPBOX_API_KEY,
    style: 'light',
}
